import { render } from "./card.vue?vue&type=template&id=a123aece&scoped=true"
import script from "./card.vue?vue&type=script&lang=ts"
export * from "./card.vue?vue&type=script&lang=ts"

import "./card.vue?vue&type=style&index=0&id=a123aece&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a123aece"

export default script